import React from 'react';
import {
  reduxForm, formValueSelector, change, getFormValues,
} from 'redux-form';
import { connect } from 'react-redux';
import ClinicalInformation from './clinicalInformationComponent';
import { handleClinicalInformationIsNotProvided } from './clinicalInformationHelper';
import { userRoles } from '../../constants';

let ClinicalInformationForm = ({ formValues, dispatch, clinicalInformationIsNotProvided, hasWritePermission }) => (
  <fieldset className="form clinical-information-form" disabled={!hasWritePermission}>
    <ClinicalInformation
      clinicalInformationIsNotProvided={clinicalInformationIsNotProvided}
      handleNotProvided={() => {
        handleClinicalInformationIsNotProvided(formValues, dispatch);
      }}
    />
  </fieldset>
);


ClinicalInformationForm = reduxForm({
  form: 'caseClinicalInformation', // a unique identifier for this form
  destroyOnUnmount: false,
  forwardRef: true,
})(ClinicalInformationForm);

const selector = formValueSelector('caseClinicalInformation');

const mapStateToProps = state => {
  const {
    auth: { user },
  } = state;
  const clinicalInformationIsNotProvided = selector(state, 'clinicalInformationIsNotProvided');
  const initValues = state._case.selectedCase.partOneClinicalInformation;
  const hasWritePermission = user.role === userRoles.admin || user.role === userRoles.surgeon;
  return {
    user,
    initialValues: initValues,
    enableReinitialize: true,
    clinicalInformationIsNotProvided,
    formValues: getFormValues('caseClinicalInformation')(state),
    hasWritePermission,
  };
};

const mapDispatchToProps = dispatch => ({
  changeInputField: (field, val) => {
    dispatch(change('caseClinicalInformation', field, val));
  },
});

ClinicalInformationForm = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClinicalInformationForm);
export default ClinicalInformationForm;
